import { useCallback, useState } from "react";
import dataService from "../../../helpers/dataService";
import { avecDemandeAJour } from "./effacementDonnees";

export const PAR_PAGE = 10;

const useEffacementDonnees = () => {
  const [email, setEmail] = useState("");
  const [apercu, setApercu] = useState(null);
  const [demande, setDemande] = useState(null);
  const [panneauOuvert, setPanneauOuvert] = useState(false);
  const [registre, setRegistre] = useState({ data: [], total: 0, page: 1 });
  const [registreCharge, setRegistreCharge] = useState(false);
  const [rechercheEnCours, setRechercheEnCours] = useState(false);
  const [envoiEnCours, setEnvoiEnCours] = useState(false);

  const actualiser = useCallback(
    (id) =>
      dataService.get(`effacements/${id}`, (detail) => {
        setDemande(detail);
        setRegistre((courant) => avecDemandeAJour(courant, detail));
      }),
    []
  );

  const consulter = (id) => {
    if (demande?.id !== id) setDemande(null);
    setPanneauOuvert(true);
    actualiser(id);
  };

  const fermerPanneau = () => setPanneauOuvert(false);

  const chargerRegistre = useCallback(
    (page = 1) =>
      dataService.get(`effacements?page=${page}&parPage=${PAR_PAGE}`, (resultat) => {
        setRegistre({ data: resultat.data, total: resultat.total, page: resultat.page });
        setRegistreCharge(true);
      }),
    []
  );

  const apercevoir = () => {
    setApercu(null);
    setRechercheEnCours(true);
    dataService.post(
      "effacements/apercu",
      { email },
      setApercu,
      () => {},
      () => setRechercheEnCours(false)
    );
  };

  const effacer = () => {
    setEnvoiEnCours(true);
    dataService.post(
      "effacements",
      { email: apercu.email },
      ({ id }) => {
        setApercu(null);
        setEmail("");
        chargerRegistre(1);
        consulter(id);
      },
      () => {},
      () => setEnvoiEnCours(false)
    );
  };

  const relancer = (id) =>
    dataService.post(`effacements/${id}/relance`, {}, () => actualiser(id));

  const abandonner = (id) =>
    dataService.post(`effacements/${id}/abandon`, {}, () => actualiser(id));

  return {
    email,
    setEmail,
    apercu,
    demande,
    panneauOuvert,
    registre,
    registreCharge,
    rechercheEnCours,
    envoiEnCours,
    actions: { apercevoir, effacer, consulter, fermerPanneau, actualiser, relancer, abandonner, chargerRegistre },
  };
};

export default useEffacementDonnees;
